import { useQuery } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { eventsApi } from 'src/Services/API';

const useFetchEvent = (eventId?: string) => {
  const assetId = useCurrentAssetId();

  return useQuery({
    queryKey: ['fetch-event', eventId],
    queryFn: async () => {
      if (!assetId) throw new Error('No assetId provided');
      if (!eventId) throw new Error('No eventId provided');

      return (await eventsApi.eventsControllerFindOne(assetId, eventId)).data;
    },
    enabled: !!assetId && !!eventId,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};

export default useFetchEvent;
